import { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { updateCheckData } from "../../studentPreChecksSlice"
import { PRE_CHECK_MACHINE_STATES } from "../../constants"

const DELAY_VOLUME_STATS_POLL = 1000 // MS
const VOLUME_STATS_POLL_FREQUENCY = 200 // MS

export default function useSpeechVolumeLevel({ speechProps, shouldStartVolumeProcessing }) {

    const dispatch = useDispatch()

    const [volumeLevel, updateVolumeLevel] = useState({})
    const volumeCheckInterval = useRef()

    useEffect(()=>{
        if (shouldStartVolumeProcessing) {
            speechProps.stopListening()
            speechProps.startVolumeProcessing()
            toggleMeasuringStatus(true)
            const delayedFetching = setTimeout(startFetching, DELAY_VOLUME_STATS_POLL)
            return ()=>{
                speechProps.stopVolumeProcessing()
                toggleMeasuringStatus(false)
                clearTimeout(delayedFetching)
                clearInterval(volumeCheckInterval.current)
                updateVolumeLevel({})
            }
        }
    }, [])

    const toggleMeasuringStatus = (isMeasuring) => {
        dispatch(updateCheckData({
            type: PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks,
            data: {
                isMeasuringVolume: isMeasuring
            }
        }))
    }

    const startFetching = () => {
        volumeCheckInterval.current = setInterval(fetchVolumeLevel, VOLUME_STATS_POLL_FREQUENCY)
    }

    const fetchVolumeLevel = () => {
        const level = speechProps.volumeStatistics()
        updateVolumeLevel(level)
    }

    return {
        volumeLevel
    }
}